import { Dropdown } from 'antd'
import React from 'react'
import Archive from '../../../../../assets/Images/Archive.svg'
import Chat from '../../../../../assets/Images/chat.svg'
import Attende from '../../../../../assets/Images/attendees.svg'
import Ticket from '../../../../../assets/Images/Ticket.svg'
import Rename from '../../../../../assets/Images/rename.svg'
import Register from '../../../../../assets/Images/register.svg'
import Live from '../../../../../assets/Images/liveUpdate.svg'
import Mentor from '../../../../../assets/Images/mentors.svg'
import EventManager from '../../../../../assets/Images/event-manager.svg'
import Copy from '../../../../../assets/Images/CopySimple.svg'
import Checkin from '../../../../../assets/Images/CheckSquare.svg'
import { Link, useHistory } from 'react-router-dom'
import { creationEventStore } from 'state/event/eventCreationStore'
import { useChangeExternalStatus } from 'api/External/External'
import { useChangeCommunityStatus } from 'api/Community/CommunityCreation'
import ButtonSpinner from 'components/global/ButtonSpinner'
import { useQueryClient } from '@tanstack/react-query'
import { PaginatedCommonEventResp } from 'types/event/events'
import { useArchiveEvent } from 'api/EventCreation/EventCreation'
import { infoMessage } from 'api/global'
import { set } from 'lodash'

interface ManageBtn {
  id: string
  name: string
  status?: string
  type?: 'event' | 'league' | 'community' | 'external'
  btnName?: string
}
const ManageButton: React.FC<ManageBtn> = ({
  type,
  id,
  status,
  name,
  btnName,
}) => {
  const { setEventStepCounter, setEventData, setDuplicateModalOpen } =
    creationEventStore(store => ({
      setEventStepCounter: store.setStepCounter,
      setEventData: store.setEventData,
      setDuplicateModalOpen: store.setDuplicateModalOpen,
    }))

  const {
    mutate: changeExternalStatusMutation,
    isLoading: changeExternalStatusMutationLoading,
  } = useChangeExternalStatus()
  const {
    mutate: changeCommunityStatusMutation,
    isLoading: changeCommunityStatusMutationLoading,
  } = useChangeCommunityStatus()
  const {
    mutate: archiveEventMutation,
    isLoading: archiveEventMutationLoading,
  } = useArchiveEvent()

  const getBtnText = (type: 'event' | 'league' | 'community' | 'external') => {
    if (type === 'event') return 'Event'
    else if (type === 'league') return 'League'
    else if (type === 'community') return 'Community'
    else if (type === 'external') return 'External'
    else return 'Edit'
  }

  const handleArchiveClick = () => {
    const payload = {
      status: status === 'archived' ? 'draft' : 'archived',
    }
    if (type === 'external') {
      changeExternalStatusMutation({ payload, externalId: id })
    } else if (type === 'community') {
      changeCommunityStatusMutation({ payload, communityId: id })
    } else if (type === 'event') {
      archiveEventMutation({ payload, eventId: id })
    } else {
      infoMessage('We are working to make it live soon')
    }
  }

  const handleDuplicateCLick = () => {
    setDuplicateModalOpen(true)
    setEventData({ id: id })
  }

  const handleEditClick = () => {
    if (type === 'event') {
      setEventStepCounter(0)
      setEventData(null)
    }
  }

  const ManageEvent = [
    {
      key: 'contact',
      label: (
        // <Link to={`/event-chat/${id}`}>
        <Link to={`${type === 'event' ? `/event-chat/${id}` : ''}`}>
          <div className="flex align-center">
            <img src={Chat} alt="contac-attende" />
            <h4 className="w-500 text-14 ml-10px">Contact attendees</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'register',
      label: (
        <div className="flex align-center">
          <img src={Ticket} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">Register</h4>
        </div>
      ),
    },
    {
      key: 'check-in',
      label: (
        <Link to={`/spaces/${id}?tab=attendance`}>
          <div className="flex align-center">
            <img src={Checkin} alt="contac-attende" />
            <h4 className="w-500 text-14 ml-10px">Check-in</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'Live',
      label: (
        <div className="flex align-center">
          <img src={Live} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">Live Updates</h4>
        </div>
      ),
    },
    {
      key: 'edit',
      label: (
        <Link
          to={
            type === 'event'
              ? `/spaces/update-event/${id}`
              : type === 'league'
              ? `/spaces/update-league/${id}`
              : type === 'community'
              ? `/update-community/${id}`
              : `/update-external/${id}`
          }
          onClick={handleEditClick}
        >
          {/* <Link to={`/spaces/update-event/${id}`}> */}
          <div className="flex align-center">
            <img src={Rename} alt="contac-attende" />
            <h4 className="w-500 text-14 ml-10px">{`Edit ${getBtnText(
              type,
            )} `}</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'archive',
      label: (
        <div className="flex align-center" onClick={handleArchiveClick}>
          <img src={Archive} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">{`${
            status === 'archived' ? 'Unarchive' : 'Archive'
          } ${getBtnText(type)} `}</h4>
        </div>
      ),
    },
    {
      key: 'duplicate',
      label: (
        <div
          className="flex align-center border-btm pb-15px"
          onClick={handleDuplicateCLick}
        >
          <img src={Copy} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">Duplicate event</h4>
        </div>
      ),
    },
    {
      key: 'attendees',
      label: (
        // <div className="flex align-center">
        //   <img src={Attende} alt="contac-attende" />
        //   <h4 className="w-500 text-14 ml-10px">Attendees</h4>
        // </div>
        <Link to={{ pathname: `spaces/${id}/attendess`, state: { name } }}>
          <div className="flex align-center">
            <img src={Attende} alt="contac-attende" />
            <h4 className="w-500 text-14 ml-10px">Attendees</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'Mentor',
      label: (
        <div className="flex align-center">
          <img src={Mentor} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">Mentors</h4>
        </div>
      ),
    },
    {
      key: 'Event',
      label: (
        <div className="flex align-center">
          <img src={EventManager} alt="contac-attende" />
          <h4 className="w-500 text-14 ml-10px">Event manager</h4>
        </div>
      ),
    },
  ]

  const onClick = ({ key }: any) => {}
  return (
    <Dropdown
      menu={{
        items: ManageEvent,
        onClick,
      }}
      placement="bottomLeft"
      arrow={false}
      className="mr-10px "
      overlayStyle={{ width: '250px' }}
    >
      <button className="w-500 prim-sm-btn">
        {changeExternalStatusMutationLoading ||
        changeCommunityStatusMutationLoading ||
        archiveEventMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : btnName !== undefined ? (
          btnName
        ) : (
          `Manage ${getBtnText(type)}`
        )}
      </button>
    </Dropdown>
  )
}
export default ManageButton
